import type { User } from '../types';
import type { DashboardClientId } from '../pages/dashboardRouting';
import { mapDisplayClientId } from '../services/dashboardApi';
import type { BackendClientId } from '../services/dashboardApi';
import { isDwaUser } from '../hubs/hubs';

/**
 * The floating Lupa widget shows on every DWA page except the Lupa Hub itself
 * (the full page already is the chat) and login (07-hubs §5). Client-role users
 * never get Lupa.
 */
export function shouldShowLupaWidget(pathname: string, user: User | null | undefined): boolean {
  if (!isDwaUser(user)) return false;
  if (pathname === '/login') return false;
  if (pathname === '/lupa' || pathname.startsWith('/lupa/')) return false;
  return true;
}

/**
 * Client-role users only ever see their first assigned client's dashboard
 * (unchanged from the hash router). Null when the account has no client yet.
 */
export function clientDashboardId(user: User | null | undefined): DashboardClientId | null {
  const first = user?.client_access?.[0];
  if (!first) return null;
  return mapDisplayClientId(first.client_id as BackendClientId) as DashboardClientId;
}
